const i18nConfig = {
	locales: ["en", "fr", "nl"],
	defaultLocale: "fr",
};

module.exports = i18nConfig;
